import React, { useEffect } from 'react';
import {
    Dialog, DialogTitle,
    DialogContent, DialogActions
} from '@mui/material';


import WizardContentComponent from '../wizard-content/wizard-content.component';
import WizardFooterComponent from '../wizard-footer-bar/wizard-footer-bar.component';
import WizardTitleBarComponent from '../wizard-title-bar/wizard-title-bar.component';
import { useWizardStepperContext } from '../../contexts/useWizardStepper.context';


interface IProps {
    open: boolean;
    onClose: (reloadAll: boolean) => void;
    reportCode: string | undefined | null;
}
/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardDialogComponent({ open, onClose, reportCode }: IProps) {

    const { handleReset } = useWizardStepperContext();

    const handleClose = () => {
        handleReset();
        onClose(false);
    }

    return (<Dialog open={open} scroll='paper' maxWidth='lg' fullWidth>

        {/* header */}
        <DialogTitle sx={{ p: 1 }}>
            <WizardTitleBarComponent onClose={handleClose} />
        </DialogTitle>

        {/* content */}
        <DialogContent dividers sx={{ height: '592px', p: 0, m: 0 }}>
            <WizardContentComponent onClose={onClose} reportCode={reportCode} />
        </DialogContent>

        {/* footer */}
        <DialogActions sx={{ p: 3 }}>
            <WizardFooterComponent />
        </DialogActions>

    </Dialog>)
}